 import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
Swiper.use([Navigation, Pagination]);


var casesSwiper = new Swiper('.cases__slider', {
  slidesPerView: 1,
  spaceBetween: 24,
  navigation: {
    nextEl: '.cases__nav-next',
    prevEl: '.cases__nav-prev'
  },
  breakpoints: {
    // 768px и выше - 2 слайда
    768: {
      slidesPerView: 2,
      spaceBetween: 24
    },

    // 1280px и выше - 3 слайда с большим отступом
    1280: {
      slidesPerView: 3,
      spaceBetween: 30
    }
  }
});
// ===================== REVIEWS SLIDER =====================

var reviewsSwiper = new Swiper('.reviews__slider', {
  slidesPerView: 1,
  spaceBetween: 20,
  loop: true,
  centeredSlides: false,

  breakpoints: {
    // Мобильные - 1 слайд
    320: {
      slidesPerView: 1,
      spaceBetween: 15,
    },
    480: {
      slidesPerView: 1,
      spaceBetween: 15,
    },
    // Планшет - 2 слайда
    640: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    // Десктоп - 3 слайда
    1024: {
      slidesPerView: 2.2,
      spaceBetween: 20,
    },

  },

  // Навигация
  navigation: {
    nextEl: '.reviews__slider .swiper-button-next',
    prevEl: '.reviews__slider .swiper-button-prev',
  },

  // Пагинация
  pagination: {
    el: '.reviews__slider .swiper-pagination',
    clickable: true,
  },

  // Автопрокрутка
  autoplay: {
    delay: 5000,
    disableOnInteraction: true,
  },

  speed: 600,
});
// Выравнивание высоты блоков
function equalHeight() {
  const tops = document.querySelectorAll('.case-card__body-top');
  let maxHeight = 0;

  tops.forEach(el => {
    el.style.height = 'auto';
    const height = el.offsetHeight;
    if (height > maxHeight) maxHeight = height;
  });

  tops.forEach(el => {
    el.style.height = maxHeight + 'px';
  });
}

// Запускаем после загрузки и при изменении окна
window.addEventListener('load', equalHeight);
window.addEventListener('resize', equalHeight);

// ===================== ВИДЕО ПЛЕЕР (MP4) =====================

document.addEventListener('DOMContentLoaded', function() {
  const playButtons = document.querySelectorAll('.review-card__play-btn');
  const stopButtons = document.querySelectorAll('.review-card__stop-btn');
  let activeVideo = null;

  // Кнопка воспроизведения
  playButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const photo = this.closest('.review-card__photo');
      const videoUrl = this.dataset.video;

      // Если уже есть активное видео, выключаем его
      if (activeVideo && activeVideo !== photo) {
        stopVideo(activeVideo);
      }

      // Проверяем, есть ли уже видео в текущем блоке
      let videoContainer = photo.querySelector('.review-card__video');

      if (!videoContainer) {
        // Создаем контейнер для видео
        videoContainer = document.createElement('div');
        videoContainer.className = 'review-card__video active';

        // Создаем video элемент
        const video = document.createElement('video');
        video.src = videoUrl;
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');

        videoContainer.appendChild(video);
        photo.appendChild(videoContainer);

        // Скрываем кнопку play и добавляем класс
        this.style.display = 'none';
        photo.classList.add('video-active');

        // Запускаем видео
        video.play();
        activeVideo = photo;

        // Обработчик окончания видео
        video.addEventListener('ended', function() {
          stopVideo(photo);
        });

      } else {
        // Если видео уже есть, показываем его и перезапускаем
        videoContainer.classList.add('active');
        this.style.display = 'none';
        photo.classList.add('video-active');

        const video = videoContainer.querySelector('video');
        if (video) {
          video.play();
        }
        activeVideo = photo;
      }
    });
  });

  // Кнопка остановки
  stopButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const photo = this.closest('.review-card__photo');
      stopVideo(photo);
    });
  });

  // Функция остановки видео
  function stopVideo(photo) {
    const videoContainer = photo.querySelector('.review-card__video');
    const playBtn = photo.querySelector('.review-card__play-btn');
    const stopBtn = photo.querySelector('.review-card__stop-btn');

    if (videoContainer) {
      const video = videoContainer.querySelector('video');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }

      videoContainer.classList.remove('active');
      // Удаляем видео контейнер через небольшую задержку
      setTimeout(() => {
        if (videoContainer) {
          videoContainer.remove();
        }
      }, 300);
    }

    if (playBtn) {
      playBtn.style.display = 'flex';
    }

    photo.classList.remove('video-active');

    if (activeVideo === photo) {
      activeVideo = null;
    }
  }
});
